import React from "react";
import {
    GiftGuideContainer,
    Main,
    ImageContainer,
    Link,
    Image,
    Information,
    Span,
    Header,
    Text,
    Strong,
} from "../../styles/GiftGuide";

// images
import mainImg from "assets/images/gift-guide/mainImg.jpg";

function GiftGuide(props) {
    return (
        <GiftGuideContainer>
            <Main className="container">
                <ImageContainer>
                    <Link>
                        <Image src={mainImg} className="img-fluid" />
                        <Information>
                            <Span>GIFT GUIDE 2021</Span>
                            <Header>
                                Carefully selected
                                <br />
                                <Strong>gift items</Strong>
                            </Header>

                            <Text>
                                Classic seasonal gifts from Ruhlistic to make
                                holidays for your loved ones special
                            </Text>
                        </Information>
                    </Link>
                </ImageContainer>
            </Main>
        </GiftGuideContainer>
    );
}

export default GiftGuide;
